import Cookies from "js-cookie";

const originToSend = Cookies.get('ref');

export const isIframe = window !== window.top && originToSend;
// export const isIframe = true;